import { useDeviceBreakpoint } from "@ui/hooks/useDeviceBreakpoint";

import { Button } from "@jti/core-components/components/Button";

import styles from "./ActionButtons.module.scss";

export type ActionButtonsProps = {
  isError?: boolean;
  isPassVerification?: boolean;
  isPrimaryButtonVisible?: boolean;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick: () => void;
};

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  isError,
  isPassVerification,
  isPrimaryButtonVisible = true,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonLabel,
  secondaryButtonLabel,
}) => {
  const { breakpoint } = useDeviceBreakpoint();
  return (
    <div className={styles.wrapper}>
      {isPrimaryButtonVisible && (
        <Button
          onClick={onPrimaryButtonClick}
          type="submit"
          size={breakpoint === "desktop" ? "lg" : undefined}
          variant="primary"
          className={isError ? "dark-theme" : "light-theme"}
          data-testid="primaryButtonAgeVerification"
        >
          {primaryButtonLabel}
        </Button>
      )}
      <Button
        onClick={onSecondaryButtonClick}
        data-testid="secondaryButtonAgeVerification"
        size={breakpoint === "desktop" ? "lg" : undefined}
        variant={isPassVerification ? "primary" : "secondary"}
      >
        {secondaryButtonLabel}
      </Button>
    </div>
  );
};
